/**
 * @file recruiter.tsx
 *
 * @fileoverview This is the registration page and is accessed by going to "/user/register/recruiter".
 * The page displays a form for the recruiter to provide his register information and on submit
 * will make a call to register the recruiter.
 */
import JobiqoRegisterPage, {
  getServerSideProps,
} from '~/jobiqo/pages/user/register';
export default JobiqoRegisterPage;
export { getServerSideProps };
